module.exports = __webpack_public_path__ + "static/warsaw-2026-0ce40a6a0fbb401a9c2011d616fca861.png";